import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SessionService } from '../../shared/services/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { RequiredReturnUrl } from '../../model/enum/required-return-url.enum';
import { AmountPipe } from '../../shared/pipes/amount.pipe';
import { NzModalService } from 'ng-zorro-antd';
import { SubjectService } from '../../shared/services/subject/subject.service';
import { SdkInitText } from '../../model/user/sdk-init-text';
import { UpdateOrderForCreditProvider } from "../../model/update.order.for.credit.provider";
import { UserService } from "../../shared/services/user.service";

@Component({
  selector: 'pa-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss']
})
export class MobileHeaderComponent implements OnInit, OnChanges {

  defaultUrl = 'https://paycell.com.tr/';
  @Input('deadLine') deadline = null;
  @Input('brandIcon') brandIcon: string;
  @Input('sdkInitTexts') sdkInitTexts: SdkInitText[];
  @Input('amount') amount: string;
  @Input('returnUrl') returnUrl: string;
  loginWebSdk: boolean;
  getResultUrl: string;
  amountPipe: AmountPipe = new AmountPipe();
  countdownShow: boolean = true;
  returnButtonShow: boolean = true;
  trackingId: string;

  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService, private sessionService: SessionService, private location: Location,
              private subjectService: SubjectService, private changeDetectionRef: ChangeDetectorRef, private modalService: NzModalService) {
  }

  ngOnInit(): void {
    this.trackingId = window.location.href.substr(window.location.href.lastIndexOf('/') + 1), window.location.href.lastIndexOf('?');
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.subjectService.amountSubject$.subscribe(amount => {
      if (!!amount) {
        this.amount = this.amountPipe.transform(amount / 100);
        this.changeDetectionRef.detectChanges();
      }
    });
    this.subjectService.checkoutResultPageGuidelinesSubject$.subscribe(response => {
      this.countdownShow = response?.countDownShow;
      this.returnButtonShow = response?.returnButtonShow;
      this.changeDetectionRef.detectChanges();
    });
  }

  stop() {
    this.deadline = null;
    this.changeReturnUrlForLoginWebSdk();
    this.router.navigate(['/result/timeout', this.trackingId]);
    this.changeDetectionRef.detectChanges();
    this.modalService.closeAll();
    return;
  }

  onClick() {
    if (this.checkRequiredReturnUrl()) {
      this.location.back();
    } else if (this.threeDAddCardUrlCheck()) {
      this.router.navigate(['/payment/selection', this.trackingId]);
      return;
    } else {
      if (this.returnUrl === 'undefined' || this.returnUrl === null) {
        window.location.href = this.defaultUrl;
      } else {
        this.changeReturnUrlForLoginWebSdk();
        const pattern = new RegExp('^(https?|http)://');
        if (pattern.test(this.returnUrl)) {
          let provider = new UpdateOrderForCreditProvider(null, 'BACK');
          this.userService.updateOrderForCreditProvider(this.trackingId, provider).subscribe();
          window.location.href = this.returnUrl;
        } else {
          window.location.href = this.defaultUrl;
        }
      }
    }
  }

  checkRequiredReturnUrl() {
    let result = false;
    let requiredReturnUrls = Object.entries(RequiredReturnUrl);
    requiredReturnUrls.forEach(url => {
      if (this.router?.url === url[1] + "/" + this.trackingId) {
        result = true;
      }
    });
    return result;
  }

  threeDAddCardUrlCheck() {
    let result = false;
    const url = this.router.url.split('/');
    const childUrl = '/' + url[1] + '/' + url[2];
    if (RequiredReturnUrl.PAYMENT_ADD_CARD === childUrl && url.length === 5) {
      result = true;
    }
    return result;
  }

  keyValueMapping(key: string, replacementValue: string): string {
    let value = null;
    if (this.sdkInitTexts == null) {
      value = replacementValue;
    } else {
      let sdk = this.sdkInitTexts.find(text => text.name === key);
      if (sdk != null) {
        value = sdk.value;
      } else {
        value = replacementValue;
      }
    }
    return value;
  }

  changeReturnUrlForLoginWebSdk() {
    if(this.loginWebSdk) {
      this.returnUrl = this.getResultUrl;
    }
  }

}
